/* AB   HFB-046-MD-CART-AB */

(function() {
  var isProcessing = false;

  function setProcessing(state) {
    isProcessing = state;
    document.querySelectorAll('.sub-save-new').forEach(function(w) {
      if (state) {
        w.classList.add('sub-save-new--processing');
      } else {
        w.classList.remove('sub-save-new--processing');
      }
    });
  }

  function watchOverlay() {
    var checkCount = 0;
    var maxChecks = 50;
    var checkInterval = setInterval(function() {
      checkCount++;
      var overlay = document.getElementById('cart-overlay');
      if (!overlay || overlay.style.display === 'none' || overlay.style.display === '') {
        clearInterval(checkInterval);
        setProcessing(false);
        syncAllStates();
        return;
      }
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
        setProcessing(false);
        syncAllStates();
      }
    }, 100);
  }

  function getControlCheckbox(wrapper) {
    var rcItem = wrapper.closest('.rc90-item');
    if (rcItem) {
      return rcItem.querySelector('.upsell__checkbox');
    }
    var variantId = wrapper.dataset.variantId;
    return document.getElementById('sellingPlanCheckbox-' + variantId);
  }

  function getControlOptions(wrapper) {
    var rcItemMain = wrapper.closest('.rc90-item-main');
    return rcItemMain ? rcItemMain.querySelector('.upsell__options') : null;
  }

  function getLineItemKey(wrapper) {
    var rcItem = wrapper.closest('.rc90-item');
    if (rcItem) {
      var removeBtn = rcItem.querySelector('[data-line-item-key]');
      if (removeBtn) {
        return removeBtn.dataset.lineItemKey;
      }
    }
    return null;
  }

  async function updateSellingPlanFast(lineItemKey, variantId, planId) {
    if (window.robustCart && typeof window.robustCart.updateLineSellingPlan === 'function') {
      return window.robustCart.updateLineSellingPlan(lineItemKey, variantId, planId || null);
    }
    return false;
  }

  async function addSellingPlanToItem(lineItemKey, variantId, planId) {
    return updateSellingPlanFast(lineItemKey, variantId, planId);
  }

  async function removeSellingPlanFromItem(lineItemKey, variantId) {
    return updateSellingPlanFast(lineItemKey, variantId, null);
  }

  async function updateSellingPlanDirectly(lineItemKey, variantId, newPlanId) {
    return updateSellingPlanFast(lineItemKey, variantId, newPlanId);
  }

  function syncAllStates() {
    document.querySelectorAll('.sub-save-new').forEach(function(wrapper) {
      var controlCheckbox = getControlCheckbox(wrapper);
      var buttonWrapper = wrapper.querySelector('.sub-save-new__button-wrapper');
      var collapsed = wrapper.querySelector('.sub-save-new__collapsed');
      var oneTimeRadio = wrapper.querySelector('input[value="one-time"]');
      
      if (controlCheckbox && controlCheckbox.checked) {
        if (buttonWrapper) buttonWrapper.style.display = 'none';
        if (collapsed) collapsed.classList.add('sub-save-new__collapsed--active');
        var controlOptions = getControlOptions(wrapper);
        if (controlOptions && controlOptions.value) {
          var matchingRadio = wrapper.querySelector('input[value="' + controlOptions.value + '"]');
          if (matchingRadio) {
            matchingRadio.checked = true;
            var collapsedText = collapsed ? collapsed.querySelector('.sub-save-new__collapsed-text') : null;
            if (collapsedText && matchingRadio.dataset.label) {
              collapsedText.textContent = matchingRadio.dataset.label;
            }
          }
        }
      } else {
        if (oneTimeRadio) oneTimeRadio.checked = true;
        if (buttonWrapper) buttonWrapper.style.display = 'block';
        if (collapsed) {
          collapsed.classList.remove('sub-save-new__collapsed--active');
          collapsed.classList.remove('sub-save-new__collapsed--expanded');
        }
        var collapsedText = collapsed ? collapsed.querySelector('.sub-save-new__collapsed-text') : null;
        if (collapsedText && oneTimeRadio && oneTimeRadio.dataset.label) {
          collapsedText.textContent = oneTimeRadio.dataset.label;
        }
      }
    });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.sub-save-new__button');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (isProcessing) return;
    var wrapper = btn.closest('.sub-save-new');
    if (!wrapper) return;
    var options = wrapper.querySelector('.sub-save-new__options');
    var buttonWrapper = wrapper.querySelector('.sub-save-new__button-wrapper');
    var collapsed = wrapper.querySelector('.sub-save-new__collapsed');
    if (buttonWrapper) buttonWrapper.style.display = 'none';
    if (collapsed) collapsed.classList.add('sub-save-new__collapsed--active');
    var firstSubRadio = options ? options.querySelector('input[data-plan-id]') : null;
    if (firstSubRadio) {
      var collapsedText = collapsed ? collapsed.querySelector('.sub-save-new__collapsed-text') : null;
      if (collapsedText && firstSubRadio.dataset.label) {
        collapsedText.textContent = firstSubRadio.dataset.label;
      }
      firstSubRadio.checked = true;
      firstSubRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  document.addEventListener('click', function(e) {
    var collapsed = e.target.closest('.sub-save-new__collapsed');
    if (!collapsed) return;
    if (e.target.closest('.sub-save-new__options')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var wrapper = collapsed.closest('.sub-save-new');
    if (!wrapper) return;
    var options = wrapper.querySelector('.sub-save-new__options');
    var isExpanded = collapsed.classList.contains('sub-save-new__collapsed--expanded');
    if (isExpanded) {
      collapsed.classList.remove('sub-save-new__collapsed--expanded');
      if (options) options.classList.remove('sub-save-new__options--active');
    } else {
      document.querySelectorAll('.sub-save-new__collapsed--expanded').forEach(function(c) {
        if (c !== collapsed) c.classList.remove('sub-save-new__collapsed--expanded');
      });
      document.querySelectorAll('.sub-save-new__options--active').forEach(function(o) {
        if (o !== options) o.classList.remove('sub-save-new__options--active');
      });
      collapsed.classList.add('sub-save-new__collapsed--expanded');
      if (options) options.classList.add('sub-save-new__options--active');
    }
  }, true);

  document.addEventListener('mousedown', function(e) {
    if (e.target.closest('.sub-save-new')) return;
    document.querySelectorAll('.sub-save-new__collapsed--expanded').forEach(function(collapsed) {
      collapsed.classList.remove('sub-save-new__collapsed--expanded');
    });
    document.querySelectorAll('.sub-save-new__options--active').forEach(function(options) {
      options.classList.remove('sub-save-new__options--active');
    });
  });

  document.addEventListener('change', function(e) {
    var radio = e.target.closest('.sub-save-new__radio');
    if (!radio) return;
    var value = radio.value;
    var wrapper = radio.closest('.sub-save-new');
    if (!wrapper) return;
    
    var controlCheckbox = getControlCheckbox(wrapper);
    var controlOptions = getControlOptions(wrapper);
    var collapsed = wrapper.querySelector('.sub-save-new__collapsed');
    var collapsedText = collapsed ? collapsed.querySelector('.sub-save-new__collapsed-text') : null;
    var options = wrapper.querySelector('.sub-save-new__options');
    var buttonWrapper = wrapper.querySelector('.sub-save-new__button-wrapper');
    
    if (collapsedText && radio.dataset.label) {
      collapsedText.textContent = radio.dataset.label;
    }
    if (collapsed) collapsed.classList.remove('sub-save-new__collapsed--expanded');
    if (options) options.classList.remove('sub-save-new__options--active');
    if (isProcessing) return;

    if (value === 'one-time') {
      if (buttonWrapper) buttonWrapper.style.display = 'block';
      if (collapsed) collapsed.classList.remove('sub-save-new__collapsed--active');
      if (controlCheckbox && controlCheckbox.checked) {
        var lineItemKey = getLineItemKey(wrapper);
        var variantId = wrapper.dataset.variantId;
        
        if (lineItemKey && variantId) {
          setProcessing(true);
          removeSellingPlanFromItem(lineItemKey, variantId).then(function() {
            setProcessing(false);
            syncAllStates();
          });
        } else {
          setProcessing(true);
          watchOverlay();
          controlCheckbox.checked = false;
          controlCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    } else {
      if (buttonWrapper) buttonWrapper.style.display = 'none';
      if (collapsed) collapsed.classList.add('sub-save-new__collapsed--active');
      if (controlOptions) {
        controlOptions.value = value;
      }
      if (controlCheckbox) {
        var lineItemKey = getLineItemKey(wrapper);
        var variantId = wrapper.dataset.variantId;
        
        if (!controlCheckbox.checked) {
          if (lineItemKey && variantId) {
            setProcessing(true);
            addSellingPlanToItem(lineItemKey, variantId, value).then(function() {
              setProcessing(false);
              syncAllStates();
            });
          } else {
            setProcessing(true);
            watchOverlay();
            controlCheckbox.checked = true;
            controlCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          if (lineItemKey && variantId) {
            setProcessing(true);
            updateSellingPlanDirectly(lineItemKey, variantId, value).then(function() {
              setProcessing(false);
              syncAllStates();
            });
          } else {
            if (controlOptions) {
              setProcessing(true);
              watchOverlay();
              controlOptions.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }
  });

  document.addEventListener('change', function(e) {
    if (!e.target.classList || !e.target.classList.contains('upsell__checkbox')) return;
    var rcItem = e.target.closest('.rc90-item');
    var wrapper = rcItem ? rcItem.querySelector('.sub-save-new') : null;
    if (!wrapper) return;
    var options = wrapper.querySelector('.sub-save-new__options');
    var buttonWrapper = wrapper.querySelector('.sub-save-new__button-wrapper');
    var collapsed = wrapper.querySelector('.sub-save-new__collapsed');
    var oneTimeRadio = wrapper.querySelector('input[value="one-time"]');
    if (e.target.checked) {
      if (buttonWrapper) buttonWrapper.style.display = 'none';
      if (collapsed) collapsed.classList.add('sub-save-new__collapsed--active');
    } else {
      if (oneTimeRadio) oneTimeRadio.checked = true;
      if (options) options.classList.remove('sub-save-new__options--active');
      if (collapsed) {
        collapsed.classList.remove('sub-save-new__collapsed--active');
        collapsed.classList.remove('sub-save-new__collapsed--expanded');
      }
      if (buttonWrapper) buttonWrapper.style.display = 'block';
    }
  });

  function initCartObserver() {
    var cartBox = document.querySelector('.rc90-box');
    if (!cartBox) return;
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        setProcessing(false);
        syncAllStates();
      }, 300);
    });
    observer.observe(cartBox, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncAllStates();
      initCartObserver();
    });
  } else {
    syncAllStates();
    initCartObserver();
  }
})();
